import { useState } from 'react';
import { DiseaseGeneTree } from './DiseaseGeneTree';
import { DiseaseOntologyTree } from './DiseaseOntologyTree';

type TreeTab = 'disease-gene' | 'disease-ontology';

type OntologyTreeProps = {
  rootNodeId?: string;
};

const TABS: { id: TreeTab; label: string; description: string }[] = [
  {
    id: 'disease-gene',
    label: 'Disease → Gene',
    description: 'Shows diseases with their associated genes',
  },
  {
    id: 'disease-ontology',
    label: 'Disease Hierarchy',
    description: 'Shows the disease ontology hierarchy',
  },
];

export function OntologyTree({ rootNodeId }: OntologyTreeProps) {
  const [activeTab, setActiveTab] = useState<TreeTab>('disease-ontology');

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        minHeight: 0,
        background: '#f8fafc',
      }}
    >
      {/* Tab bar */}
      <div
        role="tablist"
        aria-label="Tree view"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 4,
          padding: '12px 20px 0',
          borderBottom: '1px solid #e0e8f0',
          background: '#fff',
          flexShrink: 0,
        }}
      >
        {TABS.map(tab => {
          const isActive = tab.id === activeTab;
          return (
            <button
              key={tab.id}
              role="tab"
              aria-selected={isActive}
              type="button"
              onClick={() => setActiveTab(tab.id)}
              title={tab.description}
              style={{
                padding: '9px 18px 10px',
                fontSize: 13,
                fontWeight: isActive ? 600 : 400,
                color: isActive ? '#2c6fad' : '#6b7a8d',
                border: 'none',
                borderBottom: isActive ? '2px solid #4a90d9' : '2px solid transparent',
                background: 'none',
                cursor: 'pointer',
                borderRadius: '6px 6px 0 0',
                transition: 'color 0.15s, border-color 0.15s',
                whiteSpace: 'nowrap',
              }}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      <div role="tabpanel" style={{ flex: 1, minHeight: 0, position: 'relative' }}>
        {activeTab === 'disease-gene' && <DiseaseGeneTree rootNodeId={rootNodeId} />}
        {activeTab === 'disease-ontology' && <DiseaseOntologyTree rootNodeId={rootNodeId} />}
      </div>
    </div>
  );
}
